import {
    FormControl,
    Select,
    MenuItem,
    FormHelperText,
    Button,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import { CustomRadio } from '../../../../lib/CustomRadio';
import { Grid } from '@material-ui/core';
import TextInput from '../../../../lib/TextField';
import { checkForOnlyAlphabets, isAlphaNumeric, isNumber } from '../../../../utils/constants';
import { getCountryNameFromCode } from '../../commercial/ProfileDetails/FatcaDetailsPurchase';
import { COUNTRY_DETAILS, EDIT_ACTION } from '../../commercial/ProfileDetails/FatcaEditDetails';
import enUs from '../../../../lang/en-us';
import { MAX_LENGTHS } from './utils';
import { useFlipMenuProps } from './useFlipMenu';

const { dashboard, dbCommercial } = enUs;

export default function TaxDetail({
    taxDetail,
    index,
    taxDispatch,
    countries,
    length,
    validateTaxDetail,
    state,
}: any) {
    const taxCountryFlip = useFlipMenuProps();
    const handleDelete = (index: number) => taxDispatch({ type: 'DELETE', payload: { index } });
    const handleEdit = (index: number, action: EDIT_ACTION) => {
        let dispatchValue = action === EDIT_ACTION.EDIT ? true : false;
        if (action === EDIT_ACTION.SAVE && !validateTaxDetail(taxDetail, index)) {
            return;
        }
        taxDispatch({
            type: 'CHANGE',
            payload: { index, value: dispatchValue, key: 'editing' },
        });
        if (action == EDIT_ACTION.SAVE) {
            taxDispatch({
                type: 'CHANGE',
                payload: { index, value: false, key: 'errPresent' },
            });
        }
    };
    if (!taxDetail.editing) {
        return (
            <div
                className="fatca-edit-box"
                style={{
                    borderColor: taxDetail.errPresent ? 'red' : 'white',
                    borderRadius: '2px',
                    borderStyle: 'solid',
                }}
            >
                <h3 style={{ fontSize: '1em', fontWeight: 'bold', margin: '1.33em 0' }}>
                    ID - {index + 1}
                </h3>
                <div className="fatca-edit-box-info">
                    <p>
                        {dbCommercial.newPurchase.rightMenu.fatcaEdit.countryOfTaxResidency}
                        <span>{getCountryNameFromCode(countries, taxDetail.taxResidency)}</span>
                    </p>
                    <p>
                        {dbCommercial.newPurchase.rightMenu.fatcaEdit.taxId}
                        <span> {taxDetail.tinAvailability ? 'NA' : taxDetail.tinId}</span>
                    </p>
                    <p>
                        {dbCommercial.newPurchase.rightMenu.fatcaEdit.type}
                        <span>
                            {' '}
                            {taxDetail.tinAvailability
                                ? 'Unavailable'
                                : taxDetail.identityVerification}
                        </span>
                    </p>
                </div>
                <a
                    className="edit-icon save-icon"
                    onClick={() => handleEdit(index, EDIT_ACTION.EDIT)}
                >
                    <img src="/images/edit-fill-purple.svg" alt="edit icon" />
                </a>
                {length > 1 && (
                    <a className="edit-icon" onClick={() => handleDelete(index)}>
                        <img src="/images/delete-folio.svg" alt="delete icon" />
                    </a>
                )}
            </div>
        );
    }
    return (
        <div className="curved-bg-content-inner-top fatca-middle-content">
            <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                    <div className="fatca-enter-pan">
                        <FormControl
                            variant="outlined"
                            error={!!taxDetail.errors.taxResidency}
                            ref={taxCountryFlip.anchorRef}
                        >
                            <Select
                                labelId="taxResidencyCountry"
                                id="taxResidencyCountry"
                                value={taxDetail.taxResidency || '0'}
                                onChange={({ target: { value } }) => {
                                    taxDispatch({
                                        type: 'CHANGE',
                                        payload: {
                                            index,
                                            value,
                                            key: 'taxResidency',
                                        },
                                    });
                                }}
                                onOpen={taxCountryFlip.handleOpen}
                                MenuProps={taxCountryFlip.menuProps}
                                onFocus={() => {
                                    const { taxResidency, ...rest } = taxDetail.errors;
                                    taxDispatch({
                                        type: 'CHANGE',
                                        payload: {
                                            index: index,
                                            key: 'errors',
                                            value: rest,
                                        },
                                    });
                                }}
                            >
                                <MenuItem value="0">
                                    {dashboard.FatcaDeclaration.taxResidencyCountry}
                                </MenuItem>
                                {countries.map((_ele: COUNTRY_DETAILS) => (
                                    <MenuItem value={_ele.code}>{_ele.name}</MenuItem>
                                ))}
                            </Select>
                            <FormHelperText className={'error'}>
                                {taxDetail.errors.taxResidency}
                            </FormHelperText>
                        </FormControl>
                    </div>
                </Grid>
                <Grid item xs={12} sm={7} lg={4}>
                    <div className="fatca-enter-tin">
                        <TextInput
                            label={dashboard.FatcaDeclaration.tinNo}
                            variant="outlined"
                            disabled={taxDetail.tinAvailability}
                            onChange={({ target: { value } }) => {
                                isAlphaNumeric(value) && value.length <= 50
                                    ? taxDispatch({
                                          type: 'CHANGE',
                                          payload: {
                                              index,
                                              value,
                                              key: 'tinId',
                                          },
                                      })
                                    : null;
                            }}
                            onFocus={() => {
                                const { tinId, ...rest } = taxDetail.errors;
                                taxDispatch({
                                    type: 'CHANGE',
                                    payload: {
                                        index: index,
                                        key: 'errors',
                                        value: rest,
                                    },
                                });
                            }}
                            value={taxDetail.tinId}
                            error={!!taxDetail.errors.tinId}
                            helperText={taxDetail.errors.tinId}
                        />
                        <div className="fatca-tin-nonavail">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="fatca-not-available"
                                        checked={taxDetail.tinAvailability}
                                        onChange={(e) => {
                                            if (Object.keys(taxDetail.errors).includes('tinId')) {
                                                const { tinId, ...rest } = taxDetail.errors;
                                                taxDispatch({
                                                    type: 'CHANGE',
                                                    payload: {
                                                        index: index,
                                                        key: 'errors',
                                                        value: rest,
                                                    },
                                                });
                                            }
                                            if (e.target.checked) {
                                                //clear tinId and idText
                                                taxDispatch({
                                                    type: 'CHANGE',
                                                    payload: { index, value: '', key: 'tinId' },
                                                });
                                                taxDispatch({
                                                    type: 'CHANGE',
                                                    payload: {
                                                        index,
                                                        value: '',
                                                        key: 'identityVerificationText',
                                                    },
                                                });
                                            }
                                            if (!e.target.checked) {
                                                taxDispatch({
                                                    type: 'CHANGE',
                                                    payload: {
                                                        index,
                                                        value: '',
                                                        key: 'reasonOption',
                                                    },
                                                });
                                                taxDispatch({
                                                    type: 'CHANGE',
                                                    payload: {
                                                        index,
                                                        value: '',
                                                        key: 'reasonOptionText',
                                                    },
                                                });
                                            }
                                            taxDispatch({
                                                type: 'CHANGE',
                                                payload: {
                                                    index,
                                                    value: !taxDetail.tinAvailability,
                                                    key: 'tinAvailability',
                                                },
                                            });
                                        }}
                                    />
                                }
                                label={dashboard.FatcaDeclaration.tinNotAvailable}
                            />
                        </div>
                    </div>
                </Grid>
                {!taxDetail.tinAvailability && (
                    <>
                        <Grid item xs={12} className="fatca-id-type">
                            <CustomRadio
                                extraClass="fatca-identification-type"
                                title={dashboard.FatcaDeclaration.identificationType}
                                name="identification-type"
                                list={[
                                    {
                                        label: dashboard.FatcaDeclaration.tinTxt,
                                        value: 'tin',
                                    },
                                    {
                                        label: dashboard.FatcaDeclaration.othersTxt,
                                        value: 'other-identity',
                                    },
                                ]}
                                selectedValue={taxDetail.identityVerification}
                                handleRadioChange={(value: string) => {
                                    taxDispatch({
                                        type: 'CHANGE',
                                        payload: {
                                            index,
                                            value,
                                            key: 'identityVerification',
                                        },
                                    });
                                }}
                                error={!!taxDetail.errors.identityVerification}
                                helperText={taxDetail.errors.identityVerification}
                            />
                            {taxDetail.identityVerification === 'other-identity' && (
                                <div className="fatca-enter-tin">
                                    <TextInput
                                        label={dashboard.FatcaDeclaration.typeHere}
                                        variant="outlined"
                                        value={taxDetail.identityVerificationText}
                                        onChange={({ target: { value } }) => {
                                            if (
                                                checkForOnlyAlphabets(value) &&
                                                value.length <= MAX_LENGTHS.otherIdentity
                                            ) {
                                                taxDispatch({
                                                    type: 'CHANGE',
                                                    payload: {
                                                        index: index,
                                                        key: 'identityVerificationText',
                                                        value,
                                                    },
                                                });
                                            }
                                        }}
                                        onFocus={() => {
                                            const { identityVerificationText, ...rest } =
                                                taxDetail.errors;
                                            taxDispatch({
                                                type: 'CHANGE',
                                                payload: {
                                                    index: index,
                                                    value: rest,
                                                    key: 'errors',
                                                },
                                            });
                                        }}
                                        error={!!taxDetail.errors.identityVerificationText}
                                        helperText={taxDetail.errors.identityVerificationText}
                                    />
                                </div>
                            )}
                        </Grid>
                    </>
                )}
                {taxDetail.tinAvailability && (
                    <Grid item xs={12}>
                        <CustomRadio
                            extraClass="fatca-select-reason"
                            title={dashboard.FatcaDeclaration.selectReason}
                            name="fatca-select-reason"
                            list={[
                                {
                                    label: dashboard.FatcaDeclaration.accountHolderLiable,
                                    value: 'A',
                                },
                                {
                                    label: dashboard.FatcaDeclaration.noTinRequired,
                                    value: 'B',
                                },
                                {
                                    label: dashboard.FatcaDeclaration.othersSpecify,
                                    value: 'C',
                                },
                            ]}
                            handleRadioChange={(value: string) => {
                                const { reasonOption, ...rest } = taxDetail.errors;
                                taxDispatch({
                                    type: 'CHANGE',
                                    payload: {
                                        index: index,
                                        key: 'errors',
                                        value: rest,
                                    },
                                });
                                taxDispatch({
                                    type: 'CHANGE',
                                    payload: {
                                        index,
                                        value,
                                        key: 'reasonOption',
                                    },
                                });
                            }}
                            selectedValue={taxDetail.reasonOption}
                            error={!!taxDetail.errors.reasonOption}
                            helperText={taxDetail.errors.reasonOption}
                        />
                        {taxDetail.reasonOption === 'C' && (
                            <TextInput
                                className="fatca-others-reason"
                                label={dashboard.FatcaDeclaration.typeHere}
                                variant="outlined"
                                multiline
                                rows={4}
                                onChange={({ target: { value } }) => {
                                    taxDispatch({
                                        type: 'CHANGE',
                                        payload: {
                                            index,
                                            value,
                                            key: 'reasonOptionText',
                                        },
                                    });
                                }}
                                onFocus={() => {
                                    const { reasonOptionText, ...rest } = taxDetail.errors;
                                    taxDispatch({
                                        type: 'CHANGE',
                                        payload: {
                                            index: index,
                                            key: 'errors',
                                            value: rest,
                                        },
                                    });
                                }}
                                value={taxDetail.reasonOptionText}
                                error={!!taxDetail.errors.reasonOptionText}
                                helperText={taxDetail.errors.reasonOptionText}
                            />
                        )}
                    </Grid>
                )}
                <div className="btns">
                    {length > 1 && (
                        <Button
                            className="customBtn cancelBtn"
                            onClick={() =>
                                taxDispatch({
                                    type: 'DELETE',
                                    payload: { index },
                                })
                            }
                        >
                            Delete
                        </Button>
                    )}
                    <Button
                        className="customBtn"
                        onClick={() => handleEdit(index, EDIT_ACTION.SAVE)}
                    >
                        Save
                    </Button>
                </div>
            </Grid>
        </div>
    );
}
